import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import "./css/verification.css"

const Verification = () => {
    const navigate = useNavigate();
    const { search } = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        const key = localStorage.getItem("key");
        const signtoken = localStorage.getItem("signtoken");

        if (!token || !key || !signtoken) {
             navigate("/course");
        }

        if (params.get("status") === "false" && Number(params.get("response")) === Number(1)) {
            setMessage("Your Authentication URL is invalid.");
        }
        if (params.get("status") === "false" && Number(params.get("response")) === Number(2)) {
            setMessage("Your Authentication URL is invalid.");
        }
        if (params.get("status") === "false" && Number(params.get("response")) === Number(3)) {
            setMessage("Sign up token expired, token validation is only 15 minutes.");
        }
        if (params.get("status") === "false" && Number(params.get("response")) === Number(4)) {
            setMessage("Your account authentication done successfully, go to login page and login your account.");
        }
        if (params.get("status") === "true" && Number(params.get("response")) === Number(5)) {
            console.log(params.get("token"))

            localStorage.clear();

            localStorage.setItem("token", params.get("token"));
            localStorage.setItem("user_id", params.get("user_id"));
            localStorage.setItem("name", params.get("name"));
            localStorage.setItem("email", params.get("email"));
            localStorage.setItem("status", params.get("code"));
            setMessage("Your account activated successfully.");
        }
    }, [params, navigate])

    const Gotohome = () => {
        if (params.get("status") === "true" && Number(params.get("response")) === Number(5)) {
            navigate("/course");
        } else {
            navigate("/");
        }
    }

    return (
        <div className="verificationOverlay">
            <div className="verificationModalBox">
                <div className="verificationIcon">
                    <i className="fa-solid fa-envelope-open-text"></i>
                </div>
                
                <div className="verificationMessage">
                    {message || "GO TO Home"}
                </div>
                
                <div className="verificationAction">
                    <button onClick={Gotohome} className="verificationBtn">Ok</button>
                </div>
            </div>
        </div>
    );
};

export default Verification;